var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHintIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5058 5.48319L9.62354 2.0562C9.23769 1.83141 8.76231 1.83141 8.37646 2.0562L2.49415 5.48319C2.10831 5.70799 1.87061 6.12342 1.87061 6.573V13.427C1.87061 13.8766 2.10831 14.292 2.49415 14.5168L8.37646 17.9438C8.76231 18.1686 9.23769 18.1686 9.62354 17.9438L15.5058 14.5168C15.8917 14.292 16.1294 13.8766 16.1294 13.427V6.573C16.1294 6.12342 15.8917 5.70799 15.5058 5.48319ZM10.5588 0.421485C9.59423 -0.140495 8.40577 -0.140495 7.44115 0.421485L1.55885 3.84848C0.594229 4.41046 0 5.44904 0 6.573V13.427C0 14.551 0.594229 15.5895 1.55885 16.1515L7.44115 19.5785C8.40577 20.1405 9.59423 20.1405 10.5588 19.5785L16.4412 16.1515C17.4058 15.5895 18 14.551 18 13.427V6.573C18 5.44904 17.4058 4.41046 16.4412 3.84848L10.5588 0.421485Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91104 14.9998C9.41312 14.9998 9.82013 14.5928 9.82013 14.0907C9.82013 13.5887 9.41312 13.1816 8.91104 13.1816C8.40897 13.1816 8.00195 13.5887 8.00195 14.0907C8.00195 14.5928 8.40897 14.9998 8.91104 14.9998Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90891 4.36328C8.18164 4.36328 8.18164 4.68888 8.18164 5.09055C8.18164 5.49223 8.18164 11.9087 8.18164 11.9087C8.18164 12.3104 8.50724 12.636 8.90891 12.636C9.31059 12.636 9.63619 12.3104 9.63619 11.9087C9.63619 11.9087 9.63625 5.65087 9.63626 5.09055C9.63627 4.52544 9.51581 4.36328 8.90891 4.36328Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHintIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hint-icon.40b5fdba8b3180f6bdaf15217ff10cd0.svg";